import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Vehicle } from '../../../../shared/sdk';

@Component({
  selector: 'app-vehicle-utilisation2',
  templateUrl: './vehicle-utilisation2.component.html',
  styleUrls: ['./vehicle-utilisation2.component.scss'],
})
export class VehicleUtilisation2Component implements OnInit {
  $selectedIds$: BehaviorSubject<number[]> = new BehaviorSubject([]);
  selectedId$: Observable<number> = new Observable();

  constructor() {
    this.selectedId$ = this.$selectedIds$.pipe(map(ids => (ids && ids.length ? ids[0] : null)));
  }

  ngOnInit() {}

  list_onSelected(items: Vehicle[]) {
    if (items && items.length) {
      this.$selectedIds$.next(items.map(item => item.id));
    } else {
      this.$selectedIds$.next([]);
    }
  }

  split_dragEnd(e) {
    // dxEvents.trigger(window, 'resize');
  }

  split_transitionEnd(e) {
    // dxEvents.trigger(window, 'resize');
  }
}
